import React from 'react'
import _ from 'lodash'
import isFallBackToWhiteColor from '../helpers/isFallBackToWhiteColor'
import * as StyledComponent from '../styles'

const ColorSwatch = (props, context) => {
  const white = isFallBackToWhiteColor(props.hex_value)
    ? 'white'
    : ''

  return _.isEmpty(props.swatch)
    ? <StyledComponent.ColorSwatch className={`color-swatch ${white}`} style={{ backgroundColor: props.hex_value }} />
    : <StyledComponent.ColorSwatch className={`color-swatch`}>
        <img className='shadeimg' alt='' src={props.swatch.versions.mobile_thumb_square} />
      </StyledComponent.ColorSwatch>
}

export default ColorSwatch



// WEBPACK FOOTER //
// ./src/components/ColorSwatch.js